import { Component, OnInit ,Output, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding, ViewChild,ChangeDetectorRef,ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import * as fromRoot from 'angular-engine/engine/state/reducer/core.reducer';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
@Component({
    selector: 'vg-favorite-component',
    templateUrl: './vg-favorite.template.html',
    styleUrls: ['./vg-favorite.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})



export class VgFavorite {
    @Input() favorite:boolean = false;
    @Input() item:any;
    @Input() favorites : Array<any>;
    public favoritesObject : any;
    
    private stateSubscription: Subscription;

    constructor(
        private interaction : EventInteraction,
        private state : Store<fromRoot.State>,
        private ref : ChangeDetectorRef
    ){
        const self = this;
        
        this.stateSubscription = this.state.select(fromRoot.provideFavorites)
        .subscribe(res=>{
            self.favorites = res;
            self.checkList();
        });
    }

    ngOnDestroy(){
        if (this.stateSubscription){
            this.stateSubscription.unsubscribe();
            this.stateSubscription = null;
        }
    }
    ngOnChanges( changes ){
        if(changes.item  && this.item && this.favorites ){
            this.checkList();
        } 
    } 

    private checkList () {
        if( !this.item || !this.favorites ){
            return;
        }
        
        let  unique_id;
            if (this.item && this.item.obj_type.toLowerCase() == 'episode' && this.item.video){
                unique_id = this.item.video.meta.unique_id;
            }else {
                unique_id = this.item.unique_id;
            }
            if(this.favorites){
                const match = this.favorites.find( item => {
                   return item.meta.unique_id == unique_id;
                });

                if(match){
                    this.favorite = true;
                    this.ref.detectChanges()
                }
            }
    }
    public onClick( e ){
        if ( !this.favorite )
        {
            this.favorite = true;
        }else {
            this.favorite = false;
        }
       this.interaction.next({key: "vg-favorite", message: this.favorite});
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-favorite/vg-favorite.component.ts